import toast from 'react-hot-toast';
import { PUBLIC_ENVIRONMENT } from '../../config/env';

const FAUCET_API_URL = 'https://faucet-api-evm.vercel.app/api/v1/faucet';
export const requestToken = async (
  address: string,
): Promise<string | undefined> => {
  try {
    const res = await fetch(FAUCET_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_FAUCET_API_KEY,
      },
      body: JSON.stringify({ address, chain: 'arbitrum' }),
    });
    const response = await res.json();

    if (res.status === 200) {
      toast.success('Sent tokens successfully!');
      return response.data.txHash as string;
    } else toast.error('Failed to send tokens. Try again later!');
  } catch (error) {
    toast.error('Something went wrong!');
  }
};
